<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button class="cancel-btn" fill="solid" (click)="cancel()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false">
  @if (textVisible) {
    <div class="default-content">
      <img [class.full-logo]="!isLoeufrierLogo()"
        [class.full-logo-oeufrier]="isLoeufrierLogo()" class="center-block" logo />
        <br>
          <h1 class="text-center" style="margin: 0;">Your order has been sent to the kitchen</h1>
          <p class="text-center" style="margin: 0; font-size: 19px;">A waiter will greet you shortly</p>
          <p class="text-center" style="margin-top:0; font-size: 12px;">Any modifications and additions should be addressed to the waiter</p>
        </div>
      }
    </ion-content>